module.exports = __webpack_public_path__ + "MaterialIcons-Regular.570eb83859dc23dd0eec.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/fonts/material-design-icons/MaterialIcons-Regular.woff2
// module id = ../../../../../src/assets/fonts/material-design-icons/MaterialIcons-Regular.woff2
// module chunks = 0